import { redirect } from 'react-router';
import { getIsDesktop } from '@/hooks/use-user-platform';
import ROUTES from '@/routes';

export function contactScanLoader() {
  const isDesktop = getIsDesktop();

  if (isDesktop) {
    return redirect(ROUTES.CONTACT.$path());
  }

  return {};
}
